import type { UploadRow, UploadsSummary } from '@/models/upload';

export const UPLOADS_POLL_MS = 3000;

/**
 * Poll the list and summary while any row on the page is PROCESSING or the
 * summary counts uploads in processing; otherwise don't (AP-899 R8). Derived
 * from the last data, so a failed refetch keeps polling (R13).
 */
export const uploadsPollingInterval = (
  rows: UploadRow[] | undefined,
  summary: UploadsSummary | undefined
): number =>
  (rows ?? []).some((r) => r.status === 'PROCESSING') ||
  (summary?.inProcessingCount ?? 0) > 0
    ? UPLOADS_POLL_MS
    : 0;
